import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MarkItem } from "../../_objects/mark";
import { MARK_DISABLED_COLOR } from "../../app.constants";
import { MatMenuTrigger } from "@angular/material/menu";
import { filter } from "rxjs/operators";
import { MarksStateService } from '../../_services/mark-state/marks-state.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-mark-filter',
    templateUrl: './mark-filter.component.html',
    styleUrls: ['./mark-filter.component.scss'],
    standalone: false
})
export class MarkFilterComponent {
  marks: MarkItem[];
  @Input() filterMarkControl: FormControl;
  @Output() filterChange = new EventEmitter<any>();

  @ViewChild(MatMenuTrigger) matMenuTrigger: MatMenuTrigger;

  constructor(private markState: MarksStateService) {
    this.markState.markItems$
      .pipe(takeUntilDestroyed())
      .subscribe(m => this.marks = m);
  }

  get filterMarkLabel(): string {
    const filters = this.filterMarkControl.value;
    if (filters.length === 0) {
      return '';
    } else if (filters.length === 1) {
      return this.getFilterMark(filters[0]).label;
    } else {
      return `+ ${filters.length - 1}`;
    }
  }

  getFilterMark(identifier: number): MarkItem {
    return this.marks.find(mark => mark.identifier === identifier) || new MarkItem();
  }

  markFilterMenuItemClick(identifier: number | string) {
    const isIdentifierSelected = !this.filterMarkControl.value.includes(identifier);
    const identifiers = [];

    this.marks.forEach(mark => {
      if ((identifier === mark.identifier) && isIdentifierSelected) {
        identifiers.push(mark.identifier);
      } else if ((identifier !== mark.identifier) && this.filterMarkControl.value.includes(mark.identifier)) {
        identifiers.push(mark.identifier);
      }
    });

    this.filterMarkControl.setValue(identifiers);
    this.filterChange.emit(this.filterMarkControl.value);
    this.matMenuTrigger.closeMenu();
  }

  removeFilter(identifier: MarkItem) {
    const updatedFilters = this.filterMarkControl.value.filter(filter => filter !== identifier.identifier);

    this.filterMarkControl.setValue(updatedFilters);
    this.filterChange.emit(updatedFilters);
  }

  protected readonly filter = filter;
  protected readonly MARK_DISABLED_COLOR = MARK_DISABLED_COLOR;
}
